<template>
    <div class="rec-game-item-comp" @click="enterGameDetail">
        <div class="img-sec">
            <template v-if="type == 'home-index'">
                <div class="left-top icon1" v-if="gameInfo.is_free == 1">限时免费</div>
                <div class="left-top icon2" v-else>会员免费</div>
            </template>
            <!-- 盒子官网首页在用 -->
            <template v-else-if="type == 'game-index'">
                <template v-if="gameInfo.isCompare">
                    <div class="left-top icon1" v-if="gameInfo.is_free == 1">限时免费</div>
                    <div class="left-top icon2" v-else>会员免费</div>
                </template>
            </template>
            <lazy-image :hover-class="true" :src="filterImg(gameInfo.cover_image_url)"></lazy-image>
            <!-- 右上角角标 -->
            <div class="right-top" v-if="gameInfo.is_arch == 1">支持云存档</div>
        </div>
        <div class="info">
            <div class="game-name ellipsis">
                {{ gameInfo.goods_name }}
                <!-- <template v-if="type == 'home-index'">
                    {{ gameInfo.gameName }}
                </template>
                <template>
                    {{ gameInfo.goods_id ? gameInfo.goods_name : gameInfo.title }}
                </template> -->
            </div>
            <div class="game-extra">
                <div class="left-sec">
                    <!-- 只有原价和现价都有值，并且现价大于原价，才显示原价和现价，否则显示游戏标签 -->
                    <template v-if="showPriceType === 1">
                        <div class="ellipsis">
                            <span class="sp1">
                                <i class="i1">￥</i>
                                <i class="i2">{{ current_price }}</i>
                            </span>
                            <span class="sp2">
                                <i class="i1">￥</i>
                                <i class="i2">{{ gameInfo.original_price }}</i>
                            </span>
                        </div>
                    </template>
                    <template v-else-if="showPriceType === 2">
                        <div class="tag ellipsis">
                            <span v-for="(item, index) in tagList" :key="item.id">
                                <span>{{ item.name }}</span>
                                <span class="split" v-if="index < tagList.length - 1">/</span>
                            </span>
                        </div>
                    </template>
                </div>
                <div data-agl-cvt="6" @click="dlClient" class="right-sec" :class="{ 'yellow-bg': showPriceType === 1, 'green-bg': showPriceType === 2 }">会员免费玩</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { Decimal } from 'decimal.js'

export default {
    props: {
        gameInfo: {
            type: Object,
            default: () => ({})
        },
        type: {
            type: String,
            default: ''
        }
    },
    name: 'RecGameItem',
    data() {
        return {
            current_price: 0
        }
    },
    computed: {
        ...mapState(['indexDl']),
        tagList() {
            if (this.gameInfo && this.gameInfo.tag_List && Array.isArray(this.gameInfo.tag_List) && this.gameInfo.tag_List.length) {
                return this.gameInfo.tag_List
            }
            return []
        },
        showPriceType() {
            const { goodsSpecifications, price } = this.gameInfo
            if (Array.isArray(goodsSpecifications) && goodsSpecifications.length) {
                // 获取启用状态，并且找到最低价格的商规格
                const spList = goodsSpecifications.filter((item) => item.is_enable === 1).sort((a, b) => a.current_price - b.current_price)
                if (spList[0]) {
                    const { current_price, is_sell } = spList[0]
                    // 如果最低价格没有开启单独售卖，也不展示价格
                    if (is_sell === 1) {
                        if (Decimal(current_price).gt(0) && Decimal(price).gt(0)) {
                            this.current_price = current_price
                            return 1 // 显示原价和现价
                        } else {
                            return 2 // 不显示底部价格
                        }
                    } else {
                        return 2 // 不显示底部价格
                    }
                } else {
                    return 2
                }
            } else {
                // 如果没有商品规格，则显示游戏标签
                return 2
            }
        }
    },
    methods: {
        filterImg(value) {
            return this.$Utils.filterImgUrl(value, '276x130')
        },
        enterGameDetail() {
            const { game_id, title, goods_id } = this.gameInfo
            const route = this.$router.resolve({
                path: '/landpage',
                query: {
                    game_id: game_id,
                    goods_id: goods_id
                }
            })
            const newWindow = window.open(route.href, '_blank')

            newWindow.onload = () => {
                newWindow.document.title = route.meta?.title || `乐速盒子官网-${title}`
            }
        },
        getMatchedString(str) {
            const regex = /(LesuBox_\d+(\.\d+)*_[a-zA-Z0-9_]+\.exe)/
            const match = regex.exec(str)
            if (match) {
                return match[1]
            }
            return null
        },
        dlClient(event) {
            event.stopPropagation()
            // 通知到App.vue里面去下载
            this.$EventBus.$emit('app-dl')
        }
    }
}
</script>
<style lang="less" scoped>
.rec-game-item-comp {
    color: @color-txt-high;
    width: 300px;
    background-color: #252f35;
    border-radius: 10px;
    cursor: pointer;

    .img-sec {
        position: relative;
        height: 106px;
        overflow: hidden;
        border-radius: 10px 10px 0 0;

        .left-top {
            position: absolute;
            display: none;
            width: 70px;
            height: 26px;
            border-radius: 10px 0px 10px 0px;
            font-size: 14px;
            z-index: 1;
            text-align: center;
            padding-top: 2px;
            font-weight: bold;

            &.icon1 {
                display: block;
                background: linear-gradient(90deg, #fc165b, #e80122);
            }

            &.icon2 {
                display: block;
                color: @bg-color-31;
                background: linear-gradient(90deg, #fff17f, #ffce66);
            }
        }

        .right-top {
            position: absolute;
            top: 0;
            right: 0;
            width: 82px;
            height: 26px;
            z-index: 1;
            border-radius: 0 10px 0 10px;
            background: rgba(30, 30, 30, 0.8);
            font-size: 14px;
            color: #ccc;
            text-align: center;
            padding-top: 2px;
            font-weight: bold;
        }
    }

    .info {
        padding: 16px;

        .game-name {
            font-size: 18px;
            line-height: 27px;
            margin-bottom: 23px;
        }

        .game-extra {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left-sec {
                width: 146px;
                font-size: 16px;
                color: @color-txt-normal;

                &.all-width {
                    width: 100%;
                }

                .en-name {
                    height: 17px;
                    margin-bottom: 4px;
                }

                .tag {
                    overflow: hidden;

                    .split {
                        margin: 0 4px;
                    }
                }

                .sp1 {
                    font-weight: bold;
                    color: #00eb57;
                    margin-right: 8px;

                    .i1 {
                        font-size: 18px;
                        line-height: 27px;
                        margin-right: 4px;
                    }

                    .i2 {
                        font-size: 28px;
                        line-height: 42px;
                    }
                }

                .sp2 {
                    color: #999999;
                    font-size: 16px;
                    line-height: 24px;
                    font-weight: 300;
                    text-decoration: line-through;
                }
            }

            .right-sec {
                font-size: 16px;
                border-radius: 19px;
                width: 112px;
                height: 38px;
                line-height: 38px;
                text-align: center;

                &.green-bg {
                    color: #fff;
                    background: linear-gradient(90deg, #00f14e 0%, #02cb8a 100%);
                }

                &.yellow-bg {
                    color: #7c1900;
                    background: linear-gradient(90deg, #fbdbc0 0%, #ecb493 100%);
                }
            }
        }
    }
}
</style>
